import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex)
export default new vuex.Store({//store对象
    state:{
        token: localStorage.getItem('token') || "",
        profile: JSON.parse(localStorage.getItem('profile')) || "",
        perms: new Set(JSON.parse(localStorage.getItem('perms')))
    },
    mutations: {
        set_token(state, token) {
            state.token = token
            localStorage.token = token
        },
        set_profile(state, profile) {
            state.profile = profile
            localStorage.profile = JSON.stringify(profile)
        },
        del_token(state) {
            state.token = ''
            localStorage.removeItem('token')
        },
        del_profile(state) {
            state.profile = ''
            state.perms = new Set()
            localStorage.removeItem('profile')
            localStorage.removeItem('perms')
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        hasPerm: state => (perm) =>{
            const result = state.perms.has(perm)
            return result
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js